<template>
  <div class="slider" v-bind:class="{ mini: mini }">
    <vue-flux
    :options="vfOptions"
    :images="vfImages"
    :transitions="vfTransitions"
    :captions="vfCaptions"
    ref="slider">
      <template v-slot:preloader>
        <flux-preloader />
      </template>

      <template v-slot:caption>
        <flux-caption />
      </template>

      <template v-if="slideshow.controls" v-slot:controls>
        <flux-controls />
      </template>

      <template v-if="slideshow.pagination" v-slot:pagination>
        <flux-pagination />
      </template>

      <template v-if="slideshow.slide_selector" v-slot:index>
        <flux-index />
      </template>
    </vue-flux>
  </div>
</template>

<script>
import {
  VueFlux,
  FluxCaption,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader
} from 'vue-flux'

export default {
  name: 'Slider',
  components: {
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader
  },

  data: () => ({
    vfOptions: {},
    vfImages: [],
    vfTransitions: [],
    vfCaptions: []
  }),

  mounted: function () {
    if (this.slideshow) {
      this.slideshow.slides.forEach(slide => {
        this.vfImages.push(slide.image)
        this.vfTransitions.push(slide.transition)
        this.vfCaptions.push(slide.caption)
      })

      this.vfOptions = {
        autoplay: true,
        delay: this.slideshow.delay * 1000
      }
    } else {
      this.$router.go(-1)
    }
  },
  props: ['slideshow', 'mini']
}
</script>

<style scoped>
  .mini {
    width: 868px !important;
  }

  .slider {
    width: 100vw;
  }

  @media only screen and (max-width: 920px) {
    .mini {
      width: 375px !important;
    }
  }
</style>
